<template>
  <li v-if="filterHeader.enabled">
    <div class="filter-list-title" :class="{ 'collapsed': !openHeader }" data-toggle="collapse"
      :data-target="`#${underscoredName}`">
      {{ filterHeader.name }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
      <i class="fa fa-angle-up" aria-hidden="true"></i>
    </div>
    <div :id="underscoredName" class="collapse filter-list-children" :class="{ 'in': openHeader }">
      <ul>
        <li v-for="filter in filteredSubCategories" :key="filter.id"
          :class="isFilterSelected(filter.code) ? 'filter-selected' : null"
          @click.prevent="toggle(filter, filterHeader)">
          <div>
            {{ filter.name }}
            <p v-if="filterHeader.name === 'Gloss Levels'">{{ filter.description }}</p>
          </div>
        </li>
      </ul>
    </div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "filter-header",

  props: {
    filterHeader: {
      type: Object,
      required: true,
    }
  },

  computed: {
    ...mapGetters([
      'selectedFilterOptions'
    ]),

    underscoredName() {
      return this.filterHeader.name.replace(' ', '_');
    },

    filteredSubCategories() {
      return this.filterHeader.sub_categories.filter(cat => cat.enabled);
    },

    openHeader() {
      const headerSubCategoryCodes = this.filterHeader.sub_categories.map(cat => cat.code);
      const openByDefault = ['cera_series'];
      const selectedOptionCodes = this.selectedFilterOptions.map(option => option.code);
      const headerHasSelectedSubCategories = selectedOptionCodes.some(option => headerSubCategoryCodes.includes(option));
      const headerIsOpenByDefault = openByDefault.includes(this.filterHeader.code);
      const getParentCategoryName = Object.values(this.filterHeader.parent_category_refs.map(item => item.name.toLowerCase()));

      if (this.selectedFilterOptions && getParentCategoryName.includes('collections')) {
        return this.selectedFilterOptions[0].code === this.filterHeader.code;
      }

      return headerIsOpenByDefault || headerHasSelectedSubCategories;
    }
  },

  methods: {
    ...mapActions([
      'toggleFilterOption'
    ]),

    isFilterSelected(filterCode) {
      return this.selectedFilterOptions && this.selectedFilterOptions.map(cat => cat.code).includes(filterCode);
    },

    toggle(clickedFilter, filterParent) {
      this.toggleFilterOption({ clickedFilter, filterParent });
    }
  }
}
</script>
